import React from 'react';

import { useApp } from '../../../store/AppContext';
import { BORDER_DARK, cell, DAY_ABBR, dayBorder, dayHeaderHeight } from '../shared/style';

export default function HeaderDayCell({ day }) {
  const { timelineZoom } = useApp();

  return (
    <div
      style={cell({
        textAlign: 'center',
        borderRight: dayBorder(day, timelineZoom),
        borderBottom: BORDER_DARK,
        background: day.today ? '#B9DFF5' : day.ferie ? '#EEF5FC' : day.we ? '#f7f5f0' : '#fff',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        lineHeight: 1,
        height: dayHeaderHeight(timelineZoom),
        overflow: 'hidden',
      })}
    >
      {timelineZoom === 'jour' && (
        <>
          <span
            className="text-[12px] font-medium"
            style={{
              color: day.today ? '#0C7A8A' : day.ferie ? '#185FA5' : day.we ? '#bbb' : '#9a958e',
            }}
          >
            {DAY_ABBR[day.d.getDay()]}
          </span>
          <span
            className="text-[13.5px] font-bold"
            style={{ color: day.today ? '#0C7A8A' : day.we ? '#bbb' : '#1a1a1a' }}
          >
            {day.d.getDate()}
          </span>
        </>
      )}
      {timelineZoom === 'semaine' && (
        <span className="flex flex-col items-center leading-[1.1]">
          <span className="text-[8px] text-grey-pale">{DAY_ABBR[day.d.getDay()]}</span>
          <span
            className={`text-[9.5px] ${day.today ? 'font-bold' : 'font-medium'}`}
            style={{ color: day.today ? '#0C7A8A' : day.we ? '#bbb' : '#666' }}
          >
            {day.d.getDate()}
          </span>
        </span>
      )}
      {timelineZoom === 'mois' && (
        <span
          className={`text-[8.5px] ${day.today ? 'font-bold' : 'font-normal'}`}
          style={{ color: day.today ? '#0C7A8A' : day.we ? '#cfcac3' : '#9a958e' }}
        >
          {day.d.getDate()}
        </span>
      )}
    </div>
  );
}
